<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <div class="footerNav">
            <div class="row navContent">
              <div class="col-md-6">
                <div class="row mb-4">
                  <div class="col-6">
                    <router-link
                      :to="{ path: `/${$t('imprint').toLowerCase()}` }"
                      >{{ $t("imprint") }}</router-link
                    >
                  </div>
                  <div class="col-6">
                    <router-link
                      :to="{ path: `/${$t('privacylink').toLowerCase()}` }"
                      >{{ $t("privacypolicy") }}</router-link
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-12">
                    <span>&copy; MICHAEL BULLY HERBIG</span>
                  </div>
                  <!-- <div class="col-6" @click="openLink">
                    <img
                      src="https://cms.bully-base.net/uploads/herb_X_Logo_dark_60fd260e54.svg"
                      alt="herbX Logo"
                    />
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "FooterPart",
  computed: {
    ...mapState(["cmsUrl", "screenWidth", "screenBreakLG"]),
  },
  methods: {
    openLink() {
      window.open("https://www.herbx.de", "_blank");
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/sass/main.sass'
footer
    background-color: white
    display: block
    width: 100%
    color: black
    padding: .5rem 0 0 0
    border-bottom: 15px solid $black
    .footerNav
      padding-bottom: 2rem
      padding-top: 2rem
      border-top: 1px solid lighten($lightgrey, 10%)
      margin-top: 2rem
      text-align: center
      .navContent
        width: 100%
      a
        @include border-bottom-hover($gold)
        font-size: .9rem
        margin: 0
        &.router-link-exact-active
          font-family: 'Mainfont-Bold'
      span
        font-size: .9rem
        color: $darkgrey
      img
        height: 4.5rem
        transform: translateY(-.9rem)
</style>
